<main class="container py-5">
  @if (share(); as package) {
    @if (isExpired()) {
      <div class="text-center py-5">
        <h1 class="h3">{{ share()?.revokedAt ? 'This Service Book link was revoked' : 'This Service Book link has expired' }}</h1>
        <p class="text-body-secondary mb-0">Ask the boat owner for a new time-limited share.</p>
      </div>
    } @else {
      <header class="mb-4 border-bottom pb-3">
        <p class="text-uppercase small text-primary fw-semibold mb-1">YachtApp</p>
        <h1 class="h2 mb-1">{{ package.boatName }} · Boat Service Book</h1>
        <p class="text-body-secondary mb-0">
          Shared package · expires {{ expiresLabel(package.expiresAt) }}
          @if (package.redactCosts) { · costs redacted }
          @if (package.redactPerformerDetails) { · performer details redacted }
        </p>
      </header>
      <div class="vstack gap-4">
        @for (entry of package.entries; track entry.performedAt + entry.title) {
          <article class="border-bottom pb-3">
            <h2 class="h5 mb-1">{{ entry.performedAt }} — {{ entry.title }}</h2>
            <p class="small text-body-secondary mb-2">
              {{ entry.source === 'service-record' ? 'Structured record' : 'Legacy worklog' }}
              @if (entry.voided) { · voided }
            </p>
            @if (entry.equipmentName) { <div class="small">Equipment: {{ entry.equipmentName }}</div> }
            @if (entry.system) { <div class="small">System: {{ entry.system }}</div> }
            @if (entry.performer) { <div class="small">Performed by: {{ entry.performer }}</div> }
            @if (entry.costLabel) { <div class="small">Documented cost: {{ entry.costLabel }}</div> }
            @if (entry.description) { <p class="mt-2 mb-0">{{ entry.description }}</p> }
            @if (entry.readings?.length) {
              <div class="mt-2"><strong class="small">Readings</strong><ul class="small mb-0">@for (item of entry.readings; track item) { <li>{{ item }}</li> }</ul></div>
            }
            @if (entry.parts?.length) {
              <div class="mt-2"><strong class="small">Parts</strong><ul class="small mb-0">@for (item of entry.parts; track item) { <li>{{ item }}</li> }</ul></div>
            }
            @if (entry.evidenceFilenames?.length) {
              <div class="mt-2"><strong class="small">Evidence filenames</strong><ul class="small mb-0">@for (item of entry.evidenceFilenames; track item) { <li>{{ item }}</li> }</ul></div>
            }
          </article>
        }
      </div>
      <p class="small text-body-secondary mt-4 mb-0">Evidence binaries stay in the private account store. This link only shows the shared snapshot.</p>
    }
  } @else {
    <div class="text-center py-5">
      <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading shared Service Book</span></div>
    </div>
  }
</main>
